<template>
    <vx-dropdown
        class="vx-info-title"
        align="bottom"
        justify="start"
        :is-tooltip="!allowInteraction"
    >
        <div class="flex flex-nowrap">
            <slot>
                <component :is="tag" class="line-height-inherit">
                    {{ title }}
                </component>
            </slot>
            <vx-basic-icon
                style="vertical-align: super"
                size="4"
                class="-mt-1 ml-1"
                icon="icon-info"
            />
        </div>
        <template slot="menu">
            <slot name="tooltip">
                <vx-card style="width: 350px">
                    <template v-if="title">
                        <strong>{{ title }}</strong>
                        <vs-divider></vs-divider>
                    </template>
                    <span v-html="description"></span>
                </vx-card>
            </slot>
        </template>
    </vx-dropdown>
</template>

<script>
export default {
    name: 'vx-info-title',
    props: {
        title: {
            type: String
        },
        description: {
            type: String
        },
        tag: {
            type: String,
            default: 'h5'
        },
        allowInteraction: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        hasInfoText() {
            return !!this.description
        },
        descriptionLocal() {
            return this.description || 'No Description Available'
        }
    }
}
</script>

<style lang="scss" scoped></style>
